import type { ComponentType } from "react";
import GrnPdfComponent from "./GrnPdf.jsx";

const GrnPdf = GrnPdfComponent as ComponentType<any>;
export default GrnPdf;
